import * as React from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import {  ElementoDatos } from '@componentes/Tabla/types';

interface InputProps {
    tableInfo: { id: number, descripcion: string, direccion?: string, libres?: string, nivel?: number, imagen?: string, enlace?: string, carga?: number }[];
    setTableInfo: (tableInfo: { id: number, descripcion: string, direccion?: string, libres?: string, nivel?: number, imagen?: string, enlace?: string, carga?: number }[]) => void;
}

export default function BasicTextFields({ tableInfo, setTableInfo }: InputProps) {
    const [filterValue, setFilterValue] = React.useState('');
    const rootStyles = getComputedStyle(document.documentElement);
    const principalColor = rootStyles.getPropertyValue('--primary-color');

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = event.target;
        setFilterValue(value);
        const filteredData = tableInfo.filter((row: ElementoDatos) => {
            if (row.descripcion && typeof row.descripcion === 'string') {
                return row.descripcion.toLowerCase().includes(value.toLowerCase());
            }
            return false;
        });

        setTableInfo(filteredData);
    };

    return (
        <Box
            component="form"
            sx={{
                '& > :not(style)': { m: 1, width: '25ch' },
            }}
            noValidate
            autoComplete="off"
        >
            <TextField
                id="outlined-basic"
                label="Buscar"
                variant="outlined"
                value={filterValue}
                onChange={handleChange}
                color="secondary"
                InputProps={{
                    style: { color: principalColor },
                    sx: {
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                            borderColor: principalColor,
                            color: principalColor
                        },
                        '& .MuiOutlinedInput-notchedOutline': {
                            borderColor: principalColor,
                        },
                        '&:hover .MuiOutlinedInput-notchedOutline': {
                            borderColor: principalColor, 
                        },
                        '&:focus .MuiOutlinedInput-notchedOutline': {
                            borderColor: principalColor,
                        },
                    },
                }}
                InputLabelProps={{
                    style: { color: principalColor }, 
                }}
            />
        </Box>
    );
}
